import { useEffect, useState } from 'react';
import { lastValueFrom } from 'rxjs';
import PropTypes from 'prop-types';
import { useAppSelector } from '@/redux';
import { useServices } from '@/services/useServices';
import { CallToActionKind } from '@/types';
import { getDescription } from '@/utils/innerHtmlUtils';

import CallToActionContainer from '@/components/common/callToAction/CallToActionContainer';
import Icon from '@/components/common/iconedLinks/Icon';
import CustomRater from '@/components/common/CustomRater';

import styles from './TrustedShopESpot.module.scss';
import { URLS } from '@/constants/urls';

type Rating = {
  rating: number;
  comment: string;
}
export const TrustedShopESpot = ({ data }) => {
  const { externalService } = useServices();
  const storeId = useAppSelector(({ root }) => root.storeConf.storeId);

  const [ratings, setRatings] = useState([]);

  const { contentTitle, desc, url, label, reviewLabel } = data;

  const handleOnClick = () => {
    window.open(url, '_blank');
  };

  useEffect(() => {
    const getRatings = async () => {
      try {
        if (storeId) {
          const data = await lastValueFrom(externalService.getCustomerReview(storeId));

          setRatings(data);
        }
      } catch (e) {
        console.error(e);
      }
    };

    getRatings();
  }, []);

  return ratings?.length > 0 && (
    <div className={styles.container} data-test-id="trusted-shop-espot">
      <div className={styles.title}>
        <Icon src={URLS.TRUSTEDSHOP_IMAGE} alt="trusted-shop-icon" height={48} width={48}/>
        <div>{contentTitle}</div>
      </div>
      <div className={`${styles.description} ${styles['centered-text']}`}>{desc}</div>
      <div className={styles.list}>
        {ratings.slice(0, 3).map((rating: Rating, i) => (
          <div key={i} className={styles.review}>
            <CustomRater rating={rating.rating} customClass={styles.star}/>
            <div className={styles.title}>{reviewLabel}</div>
            <div className={styles.description}>{getDescription(rating.comment, 150)}</div>
          </div>
        ))}

      </div>
      <CallToActionContainer className={styles.button} kind={CallToActionKind.SECONDARY} onClick={handleOnClick}>
        {label}
      </CallToActionContainer>
    </div>
  );
};

TrustedShopESpot.propTypes = {
  data: PropTypes.shape({
    contentTitle: PropTypes.string.isRequired,
    desc: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    reviewLabel: PropTypes.string.isRequired
  }).isRequired
};

export default TrustedShopESpot;
